import React from 'react';
import SectionHeader from '../../ui/SectionHeader';
import ArticlePreviewList from '../../ui/ArticlePreviewList';
import { Grid } from '@mui/material';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { TagItem } from '../../../shared/types';
import Loader from 'components/ui/LoadingIndicator';
import { MessageView } from 'components/ui/Feedback';
import { TAG } from '../../../gql/tags';
import { useActivityLogger } from '../../hooks/use-activity-logger';
import { sanitizeRouteId } from '../../../utils/route-params.utils';
import { isValidMongoId } from '../../../utils/id-validation.utils';

const TagPage = () => {
    const { push } = useHistory();
    const { _id: routeId } = useParams<{ _id?: string }>();
    const _id = sanitizeRouteId(routeId);
    const isValidTagId = isValidMongoId(_id);

    const errorMessage = (
        <MessageView
            styleName="primary"
            size="large"
            title="Tag not found"
            primaryAction={{
                label: 'Return to Neon Insights',
                onClick: () => push('/'),
            }}
        />
    );

    const { data, loading } = useQuery<{ document: TagItem }>(TAG, {
        skip: !isValidTagId,
        fetchPolicy: 'network-only',
        variables: { id: _id },
    });

    useActivityLogger('Tag', data?.document?.name, data?.document?._id);

    if (!isValidTagId) {
        return errorMessage;
    }

    if (loading) {
        return <Loader />;
    }

    if (!data?.document) {
        return errorMessage;
    }

    const { document: tag } = data;

    return (
        <Grid size={12}>
            <SectionHeader
                id="tag-header-section"
                title={`All articles tagged '${tag?.name}'`}
                subtitle="An aggregation of articles that have the same tag"
            />
            <ArticlePreviewList tagId={_id} source="Tag Page" />
        </Grid>
    );
};

export default TagPage;
